import {VerificationContainerComponent} from './VerificationContainerComponent';
import {VerificationDialogComponent} from './VerificationDialogComponent';
import {SetActivationCodeComponent} from './SetActivationCodeComponent';

export let loginVerificationModule = angular.module('authentication.login.verification', []);

loginVerificationModule.component('verificationContainerComponent', VerificationContainerComponent);
loginVerificationModule.component('verificationDialogComponent', VerificationDialogComponent);
loginVerificationModule.component('setActivationComponent', SetActivationCodeComponent);